import React, { useCallback, useState } from 'react';
import styled from 'styled-components';
import { FullWidthStackPanel, PREDEFINED_TABLE_STYLES } from './common';
import { StackPanel } from '../../../../../stack-panel';
import { Typography } from '../../../../../typography';
import { IValueChangeEventArgs, NumericBox } from '../../../../../numeric-box';
import { insertTable } from 'roosterjs-editor-api';
import { PrimaryButton } from '../../../../../button';
import { useToolbarActionContext } from '../../../context';

interface INumberConfigFieldProps {
    label: string;
    placeholder?: string;
    value: string;
    onChange(valueObj: IValueChangeEventArgs): void;
}

const StyledNumericBox = styled(NumericBox)`
    width: 148px;
`;

function NumberConfigField(props: INumberConfigFieldProps) {
    const { onChange, label, value, placeholder } = props;
    return (
        <StackPanel orientation="vertical">
            <Typography.Small key="text">{label}</Typography.Small>
            <StyledNumericBox key="url" step={1} blockDecimal placeholder={placeholder} value={value} onValueChange={onChange} />
        </StackPanel>
    );
}

const DEFAULT_VALUE: IValueChangeEventArgs = { valueAsString: '', sourceOfChange:'blur' };

interface IInsertTableConfigProps {
    onInsert(): void;
}

export function InsertTableConfig({ onInsert }: IInsertTableConfigProps) {
    const [rows, setRows] = useState<IValueChangeEventArgs>(DEFAULT_VALUE);
    const [columns, setColumns] = useState<IValueChangeEventArgs>(DEFAULT_VALUE);
    const { editor } = useToolbarActionContext();
    const _insertTable = useCallback(() => {
        insertTable(editor, columns.valueAsNumber ?? 0, rows.valueAsNumber ?? 0, PREDEFINED_TABLE_STYLES.get('default'));
        onInsert();
    }, [columns.valueAsNumber, onInsert, editor, rows.valueAsNumber]);
    return (
        <FullWidthStackPanel orientation="horizontal" alignment="flex-end" gap="12">
            <NumberConfigField key="rows" label="No of rows" placeholder="Rows" value={rows.valueAsString} onChange={setRows} />
            <NumberConfigField key="columns" label="No of columns" placeholder="Columns" value={columns.valueAsString} onChange={setColumns} />
            <StackPanel orientation="vertical">
                <PrimaryButton size="small" label="Insert" onClick={_insertTable} />
            </StackPanel>
        </FullWidthStackPanel>
    );
}
